import { createWebHistory, createRouter } from "vue-router";
import store from '../store'
import axios from 'axios'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/index.vue'),
        meta: {
            allowAnonymous: true,
        }
    },
    {
        path: '/result',
        name: 'Result',
        component: () => import('../views/ResultView.vue'),
        meta: {
            allowAnonymous: true,
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

router.beforeEach((to, from, next) => {

    let langCode = 'en'

    if (to.query.lang == null || to.query.lang == undefined) {
        if (localStorage.getItem('lang')) {
            langCode = localStorage.getItem('lang')
        } else {
            var browserLangCode =
                navigator.languages
                    ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

            langCode = browserLangCode.substring(0, 2).toLowerCase();

            if (browserLangCode.substring(0, 2).toLowerCase() == 'zh') {
                langCode = browserLangCode.substring(3, 5).toLowerCase()
            }
        }
    }
    else {
        langCode = to.query.lang;
    }

    switch (langCode) {
        case "pt":
        case "id":
        case "kr":
        case "cn":
        case "tw": // zh
            break;
        case "zh-TW":
            langCode = 'tw';
            break;
        case "zh-CN":
            langCode = 'cn'
            break;
        case "ko":
            langCode = 'kr'
            break;
        default:
            langCode = 'en';
            break;
    }
    store.state.lang = langCode
    next()

});

export default router
